import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import CustomPagination from "../../../../Components/CustomPagination/CustomPagination";
import {
  setLoadingFalse,
  setLoadingTrue,
} from "../../../../Config/Actions/loadingActions";
import { apiCallCheckEventAllGetUser } from "../../../../Core/Apicall";
import Icons from "../../../../Constants/Icons";
import EmptyData from "../../../../Components/EmptyData/EmptyData";

const CheckedEvent = ({ eventId }) => {
  const [eventList, setEventList] = useState([]);
  const [eventListTotalCount, setEventListTotalCount] = useState(0);
  const dispatch = useDispatch();
  useEffect(() => {
    onApiCallEventAttend();
  }, []);
  const onApiCallEventAttend = async (selectedPage) => {
    dispatch(setLoadingTrue());
    const param = {
      eventId: eventId,
      status: null,
      offset: selectedPage?.selected + 1 || 1,
      limit: 30,
    };
    try {
      const res = await apiCallCheckEventAllGetUser(param);
      setEventList(res.data);
      setEventListTotalCount(res.totalCount);
      dispatch(setLoadingFalse());
    } catch (error) {
      dispatch(setLoadingFalse());
    }
  };

  return (
    <div className="achievements">
      <div className="upcoming_list">
        <div className="margin-top-20 achievement-container">
          <div className="achievement-header ">
            <div className="achievement-title">
              <div className="astrologerText">Check-In Events</div>
            </div>
          </div>
          <div className="achievement-content">
            <div className="achievement-content-header">
              <div className="lastWeekEndDivGreyColor w-10">User Name</div>

              <div className="lastWeekEndDivGreyColor w-20">Contact</div>
              <div className="lastWeekEndDivGreyColor w-25">Venue Purchase</div>
              <div className="lastWeekEndDivGreyColor w-25">Note</div>
              <div className="lastWeekEndDivGreyColor w-20">Guest Join</div>
            </div>

            <div className="scrollable-container h-max-350">
              {eventList?.length == 0 ? (
                <EmptyData />
              ) : (
                eventList.map((items, index) => (
                  <div key={index}>
                    <div className="achievement-stretch-row">
                      <div className="fontSize16WithoutFlex w-10">
                        {items.userName}
                      </div>

                      <div
                        style={{ display: "block", gap: "4px" }}
                        className="fontSize16WithoutFlex user_name w-20"
                      >
                        <div
                          style={{
                            cursor: "pointer",
                            display: "flex",
                            alignItems: "center",
                            gap: "4px",
                          }}
                          className="fontSize16WithoutFlex"
                        >
                          <img
                            style={{
                              width: "1rem",
                              objectFit: "fill",
                              height: "1rem",
                              display: "inline-block",
                              marginRight: "2px",
                            }}
                            src={Icons.ic_sms}
                            alt="new"
                          />

                          <div className="user_text">{items.userEmail}</div>
                        </div>
                        <div
                          style={{
                            cursor: "pointer",
                            display: "flex",
                            alignItems: "center",
                            gap: "4px",
                            marginTop: "4px",
                          }}
                          className="fontSize16WithoutFlex"
                        >
                          <img
                            className="icon_style_list "
                            alt=""
                            src={Icons.ic_call}
                          />
                          <div className="user_text">{items.userMobile}</div>
                        </div>
                      </div>

                      <div className="fontSize16WithoutFlex w-25">
                        <div className="user_Status pointer">
                          <div className="user_text">
                            {items.venuePurchase ?? "-"}
                          </div>
                        </div>
                      </div>
                      <div className="fontSize16WithoutFlex w-25 ">
                        <div className="user_text">{items.note ?? "-"}</div>
                      </div>
                      <div className="fontSize16WithoutFlex w-20">
                        <div className="user_text">
                          {items.guestJoin ?? "-"}
                        </div>
                      </div>
                    </div>
                  </div>
                ))
              )}
            </div>
          </div>
        </div>
      </div>
      {eventList.length != 0 && (
        <div className="Custom-Pagination">
          <CustomPagination
            pageCount={Math.ceil(eventListTotalCount / 30)}
            pageRangeDisplayed={3}
            marginPagesDisplayed={1}
            onPageChange={onApiCallEventAttend}
          />
        </div>
      )}
    </div>
  );
};

export default CheckedEvent;
